module.exports = __webpack_public_path__ + "static/RecruitCom-dc4794c924a6ba14380b2567f3d9456e.png";